<template>
  <div class="autorisation">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-main>
          <v-container  fluid>
            <v-row class="h-100">
              <v-col class="login-col order-md-1 order-2" cols="12" sm="12" lg="5">
                <div class="logo-box">
                  <img class="logo" src="@/assets/memo_logo.png"/>
                </div>
                <div class="layer">
                <div class="login-box">
                  <div class="p-2">
                    <v-toolbar-title
                        class="d-flex justify-space-between align-center"
                        style="width: 100%"
                    >
                      <h2 class="login-title">{{ $t("authorisation.title") }}</h2>
                      
                    </v-toolbar-title>
                    <v-spacer/>
                  </div>
                  <v-card-text>
                    <v-form v-model="valid" ref="authorisation" @submit.prevent="sendForm">
                      <v-text-field
                          :label="$t('authorisation.login')"
                          name="login"
                          
                          type="text"
                          v-model="login"
                          :rules="loginRules"
                          required
                      />
                      <v-text-field
                          id="password"
                          :label="$t('authorisation.password')"
                          name="password"
                          
                          type="password"
                          v-model="password"
                          :rules="passwordRules"
                          required
                      />
                      
                        <v-spacer/>
                        <v-btn
                            type="submit"
                            class="submit_btn"
                            :class="{ disabled: disableSend === true }"
                            dark
                            color="#2196F3"
                        >{{ $t("authorisation.apply") }}
                        </v-btn
                        >
                    </v-form>
                  </v-card-text>
                </div>
                </div>
              </v-col>
              <v-col class="bg-login order-md-2 order-1" cols="12" sm="12" lg="7">
                <div class="select-box">
                  <v-select
                          :items="langs"
                          v-model="currentLang"
                          item-value="key"
                          item-text="label"
                          class="mt-2 select--lang"
                          style="max-width: 50px"
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <span>{{ item.key }}</span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <span>{{ item.key }}</span>
                        </template>
                      </v-select>
                </div>
                <div class="text-layer">
                  <h1>Ağıllı kabinetə xoş gəldiniz!</h1>
                  <p class="subheader">Ağıllı kabinet nədir?</p>
                  <p>Kabinet vasitəsilə media monitorinqin əhatəsinə düşən on-line, qəzet, TV və radio
                    məlumatlarına 24/7 prinsipinə uyğun olaraq giriş alırsınız.Sizin abunə olduğunuz
                    sektora aid məlumatlar açar sözlərə uyğun olaraq sistemə daxil edilir. Sistemdə yer
                    alan məlumatların mənbəyi və dərc olunma vaxtı göstərilir.Məlumatda yer alan açar
                    sözlər proqram tərəfindən qırmızı rəngdə qeyd olunur. Açar sözlərin fərqli rəngdə
                    işarələnməsi Sizə məlumatın əhəmiyyətli hissəsini tez tapmaqda yardımçı olur.
                  </p>
                  <p>
                    <strong>Ağıllı kabinetdə</strong> sektor üzrə yer alan məlumatları Siz ümumi və şirkətlər üzrə görə 
                    bilirsiniz. Bu məlumatları çeşidləmək, onu Word, Excel və ya html sənədinə köçürmək
                    və eyni zamanda çap etmək imkanı verir. Eyni zamanda bu kabinet vasitəsilə sektora
                    aid ötən günlərin və ya ayın məlumatını axtarış sistemi vasitəsilə tapa bilərsiniz.
                  </p>
                  <p class="subheader">Bir düymə ilə hesabat</p>
                  <p>
                    <strong>Ağıllı kabinet</strong> həmçinin dərc olunan məlumatların statistikasını mənbə, sektor və ya şirkət
                    üzrə aparmaq imkanı verir. Bir aylıq məlumatların sayını hesablamaq üçün cəmi 1 dəqiqə vaxt
                    tələb olunur. Aparılan bütün hesablamaları Excel proqramına ixrac etmək, göndərmək və ya
                    çap etmək mümkündür. Beləliklə, bütün hesabatlar "bir düymə" ilə hazır olur.
                  </p>
                </div>
                
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-app>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
import toastr from "toastr";

export default {
  name: "Autorisation",
  data: () => ({
    valid: false,
    login: "",
    password: "",
    currentLang: "en",
    langs: [
      {
        key: "ru",
        label: "Русский",
      },
      {
        key: "en",
        label: "English",
      },
      {
        key: "az",
        label: "Azərbaycan",
      },
    ],
    loginRules: [
      (v) => !!v || "Введите логин",
      (v) => v.length <= 15 || "Name must be less than 10 characters",
    ],
    passwordRules: [(v) => !!v || "Введите пароль"],
    drawer: null,
    disableSend: false,
  }),
  props: {
    source: String,
  },
  mounted() {
    this.$store.commit("stopLoader");
    this.currentLang = this.$store.state.lang = this.$i18n.locale;
    localStorage.setItem("lang", this.$i18n.locale);
    if (localStorage.hash) {
      this.$router.push("/");
    }
  },
  watch: {
    /**
     * apply chosen language
     * */
    currentLang: function () {
      this.$vuetify.lang.current = this.$i18n.locale = this.currentLang;
      localStorage.setItem("lang", this.$i18n.locale);
    },
  },
  methods: {
    sendForm() {
      if (this.$refs.authorisation.validate()) {
        this.$store.commit("startLoader");
        const request = {login: this.login, password: this.password};
        this.$axios
            .post("http://core.memo.az/account/login", request)
            .then((res) => {
              if (res.data.status == "fail") {
                localStorage.removeItem("hash");
                toastr.warning("Введеный логин или пароль не верен");
                return;
              }
              localStorage.hash = res.data.hash;
              this.$router.push("/");
            })
            .finally(() => {
              this.$store.commit("stopLoader");
            });
      }
    },
  },
};
</script>
<style lang="scss">
.autorisation i:before {
  color: #2196f3;
}

.autorisation .v-input {
  font-weight: 600;
}

.autorisation .v-text-field input {
  font-weight: 300;
  color: #757575;
}

.autorisation .v-select__selections {
  text-transform: uppercase;
}

.theme--light.v-icon {
    color: rgb(255 255 255 / 54%) !important;
}

.theme--light.v-select .v-select__selections {
    color: rgba(255, 255, 255, 0.87) !important;
    min-height: 10px;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: rgba(255, 255, 255, 0.42) !important;
}

.v-input input:invalid, .v-input textarea:invalid {
    box-shadow: none;
    border-bottom: 1px solid;
}

.bg-login {
  background-image: url("../assets/memo_bg.jpg");
  background-size: cover;
  background-position: center center;
  position: relative;    
  height: 100%;
  overflow: hidden;
}

@media screen and (max-width: 500px) {
  .bg-login {
    overflow: scroll;
  }
}

.bg-login:after {
  position: absolute;
  content: " ";
  z-index: 0;
  top: 0;
  left: 0;
  background-color: rgba(23, 29, 100, 0.9);
  min-height: 100%;
  height: 100rem;
  width: 100%;
}

.container {
  height: 100%;
}

.h-100 {
  height: 100vh;
}

.login-col {
  position: relative;
}

.logo {
  display: block;
  margin: auto;
}

.logo-box {
  width: 100%;
  height: auto;
  position: absolute;
}

.p-2 {
  padding: 20px
}

.layer {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  width: 80%;
}

.login-title {
  color: #171d64;
}

.submit_btn {
  margin-top: 2rem;
  background-color: #171d64 !important;
  border-color: #171d64 !important;
  border-radius: 20px !important;
  width: 100%;
  padding: 20px !important;
}

.text-layer {
  position: relative;
  z-index: 2;
  color: #fff;
  width: 90%;
  padding: 0 2rem;
}

.text-layer h1 {
  font-weight: bold;
  margin-bottom: 2rem;
  font-size: 2.2rem;
}

.text-layer p {
  font-size: 1rem;
  line-height: 2rem;
}

.subheader {
  font-weight: bold;
  font-size: 1.7rem !important;
}

.select-box {
  width: 100%;
  display: flex;
  position: relative;
  z-index: 3;
  align-items: center;
  flex-direction: row;
  align-content: center;
  justify-content: flex-end;
  padding-right: 3rem;
}

</style>